import React, { useContext, useEffect } from "react";
import { formatMonto, getTotalCompras } from "../../utils";
import { ModalContext } from "../../context/ModalContext";
import { AppConfigContext } from "../../context/AppConfigContext";
import { CustomerContext } from "../../context/CustomerContext";
import { AuthContext } from "../../context/AuthContext";
import useTranslations from "../../hooks/useTranslations";

const CustomerActions = ({ customer }) => {
  const translations = useTranslations();
  const usersTranslations = translations.admin.users;

  const { success } = useContext(ModalContext);
  const { domain } = useContext(AppConfigContext);
  const { signOut, recoverPassword } = useContext(AuthContext);
  const { link, getPasswordResetLink } = useContext(CustomerContext);

  useEffect(() => {
    if (link !== null && link?.length > 0) {
      let input = document.createElement("input");
      input.value = link;
      input.id = "copy-input";
      document.body.appendChild(input);
      var copyText = document.getElementById("copy-input");
      copyText.select();
      copyText.setSelectionRange(0, 99999);
      document.execCommand("copy");
      navigator.clipboard.writeText(copyText.value).then(() => {
        success("Enlace copiado al portapapeles.");
      });
      input.remove();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [link]);

  const handleLogin = () => {
    signOut();
    window.open(`https://${domain}?uid=${customer.uid}`);
  };


  return (
    <div className="container-fluid px-0">
      <h4>{usersTranslations.recoveryPass}</h4>
      <button
        className="btn btn-outline-dark me-2 my-1"
        onClick={() => recoverPassword(customer.email)}
      >
        <i className="fa fa-envelope me-2"></i> {usersTranslations.sendEmail}
      </button>
      <button
        className="btn btn-outline-dark me-2 my-1"
        onClick={() => getPasswordResetLink(customer.email)}
      >
        <i className="fa fa-link me-2"></i> {usersTranslations.generateLink}
      </button>
      <h4 className="mt-3">{usersTranslations.loginAccount}</h4>
      <button className="btn btn-outline-dark me-2 my-1" onClick={handleLogin}>
        <i className="fa fa-external-link-alt me-2"></i>{" "}
        {usersTranslations.loginAccountButton}
      </button>
      <h4 className="mt-4">
        {usersTranslations.totalPurchases}: {"$"}
        {formatMonto(getTotalCompras(customer))}
      </h4>
    </div>
  );
};

export default CustomerActions;
